import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupService } from 'src/app/Services/LookupService';
import { IFormSummaryOfPerformance } from "../../../../Models/Forms/IFormSummaryOfPerformance";
import { FormSummaryOfPerformanceService } from "../../../../Services/FormSummaryOfPerformanceService";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'SummaryOfPerformance',
  templateUrl: './SummaryOfPerformance.component.html',
  styleUrls: ['./SummaryOfPerformance.component.css']

})


export class FormSummaryOfPerformanceComponent extends SpinnerBase implements OnInit {

  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[]
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  formSummaryOfPerformanceDB: any = [];
  primaryDisabilityValues: any = [];
  reportParamArray: IReportParameter[];
  yearMinusOneDayDate: Date;
  oneYearBack: Date;
  //public showSpinner: boolean = false;
  
  firstParagraph: string = 'Attached is the Educational Plan for the above named pupil which includes the results of our conference.  We would like to have your input in pupil planning.  If you have any questions or concerns about this plan, please call me.  Our staff would be pleased to meet with you.  If we are unable to resolve any concern about assessment, planning or placements, you have the right to appeal.  Although such problems are infrequent, the procedures for appeal are included with the Educational Plan, and I will assist you if it becomes necessary to use them.  ';
  secondParagraph: string = 'Please do not hesitate to call if you have any questions regarding this letter or any of the enclosed materials. If you do not want recommended special education service(s) to continue, please contact me. Your consent is completely voluntary, but is necessary if we are to provide the service(s).';
  thirdParagraph: string ='If you consent to the special education placement/services outlined on Page 1 of the enclosed Individualized Education Plan (IEP), please initial the appropriate spaces below and sign and return one copy of this letter to us as soon as possible. We cannot begin these services for a new pupil without your written permission.';
  enclosedPlanNeedText: string = `1. The Enclosed Plan contains information regarding the lack of need/eligibility for service or that a current special education service is no longer needed for your son/daughter.`;
  enclosedPlanReviewText: string = '2.  The enclosed plan is a review and continuation of present service.';
  enclosedPlanRecommendText: string = '3. The enclosed plan contains recommended services/placement not previously provided to your son/daughter.';
  
  consentNote: string = 'Please initial each applicable statement below:';
  consentStatement1: string = `I have been advised of and given a copy of special education due process rights.`;
  consentStatement2: string = 'I have been offered a copy of the psycho-educational report. (Initial and triennial assessments only)';
  consentStatement3: string = 'Permission is granted for my child to be placed in the program/services as described in the IEP, effective';
  consentStatement4: string = 'Age of Majority has been addressed with parents. (Students 17 years of age and older)';
  consentStatement5: string = 'Age of Majority has been addressed with student. (Students 18 years of age and older)';
  consentStatement6: string = `I have been informed which agencies will be receiving my child's records and I have signed a release.`;
  consentStatement7: string = 'I request a copy of the IEP to be provided in my primary language.';
  consentStatement8: string = 'IEP has been interpreted orally and written translation is not requested. Interpreted by (when appropriate):';
  consentStatement9: string = `Has LACOE given you an opportunity to discuss your concerns about and wishes for your child's education before or during the IEP meeting?`;
  consentDeclaration: string = `I have been informed that my child cannot be assess for or placed in special education and related services without my consent. I understand that I have a right to receive this notice of consent in writing in my native language. If my language is not written, this information will be translated orally or manually. I further understand that my CONSENT IS VOLUNTARY AND CAN BE REVOKED AT ANY TIME`;


  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formSummaryOfPerformanceService: FormSummaryOfPerformanceService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }
  
  ngOnInit(): void {
    this.LoadFormSummaryOfPerformanceDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.scrollToTop();
    let iepMeetingDate = this._myGlobals.selectedIepInstance.meetingDate;
    this.yearMinusOneDayDate = new Date(iepMeetingDate.getFullYear() + 1, iepMeetingDate.getMonth(), iepMeetingDate.getDate());
    this.yearMinusOneDayDate.setDate(this.yearMinusOneDayDate.getDate() - 1);
    this.oneYearBack = new Date(iepMeetingDate.getFullYear() - 1, iepMeetingDate.getMonth(), iepMeetingDate.getDate());
    this.successMessages = [];
    this.errorMessages = [];
  }

  LoadLookupValues(): void {
    this.primaryDisabilityValues = [
      { value: "[Select One]", label: "[Select One]" },
      { value:"1",label:"Specific Learning Disability"},
      { value:"2",label:"Speech / Language Impaired"},
      { value:"3",label: "Emotionally Disturbed" },
      { value:"4",label: "Intellectual Disability" }, 
      { value:"5",label:"Hard of Hearing"},
      { value:"6",label:"Visually Impaired"},
      { value:"7",label:"Orthopedic Handicaps"},
      { value:"8",label:"Autistic - Like Behavior"},
      { value:"9",label:"Traumatic Brain Injury"},
      { value:"10",label:"Other Health Impairments"},
      { value:"11",label:"Deaf - Blindness"} ,
      { value:"12",label:"multiple Handicaps"},
      { value:"13",label:"Developmental Delays(Children aged 3 to 9)"}

    ];
   
  }

  LoadFormSummaryOfPerformanceDetails(): void {
    this._formSummaryOfPerformanceService.getFormSummaryOfPerformance(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormSummaryOfPerformance) => {
        this.formSummaryOfPerformanceDB = res;
        this.formSummaryOfPerformanceDB.dateOfSummary = this.formSummaryOfPerformanceDB.dateOfSummary == null ? null : new Date(this.formSummaryOfPerformanceDB.dateOfSummary);
        this.formSummaryOfPerformanceDB.graduationExitDate = this.formSummaryOfPerformanceDB.graduationExitDate == null ? null : new Date(this.formSummaryOfPerformanceDB.graduationExitDate);
        this.formSummaryOfPerformanceDB.studentSignedDate = this.formSummaryOfPerformanceDB.studentSignedDate == null ? null : new Date(this.formSummaryOfPerformanceDB.studentSignedDate);
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Summary Of Performance
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formSummaryOfPerformanceService.insertUpdateFormSummaryOfPerformance(this.formSummaryOfPerformanceDB)
      .subscribe((res: IFormSummaryOfPerformance) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormSummaryOfPerformanceDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  validateForm() {
    this._formSummaryOfPerformanceService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormSummaryOfPerformanceDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formSummaryOfPerformanceDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formSummaryOfPerformanceDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      //{ parameterName: 'ReportPath', parameterValue: '' },
      { parameterName: 'IEPID', parameterValue: this.formSummaryOfPerformanceDB.iepId.toString()  }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSummaryOfPerformanceDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formSummaryOfPerformanceDB.rdlFileNameSpanish, this.reportParamArray);
  }

}


